export default function (string, limit) {
  let modifyName = string;
  return modifyName.length > limit
    ? modifyName.substring(0, limit) + '...'
    : string;
}
